import React, { useState } from 'react';
import axios from 'axios'; // Import axios for API requests
import { ToastContainer, toast } from 'react-toastify'; // Import react-toastify
import 'react-toastify/dist/ReactToastify.css'; // Import toastify CSS

const faqData = [
    {
        key: 1,
        question: "What services does Sunrising Cinevision offer?",
        answer: "Sunrising Cinevision offers both professional training and production services. We provide courses in acting, direction, cinematography, editing, and also handle film production, music videos, podcast shoots, chroma studio work, photography, and event coverage."
    },
    {
        key: 2,
        question: "What types of courses are available?",
        answer: "We offer flexible learning options including crash courses, weekend batches, 1-month introductory programs, 3-month certification courses, and advanced 5+1 month programs designed for practical industry exposure."
    },
    {
        key: 3,
        question: "Do you provide real production experience?",
        answer: "Yes, students get hands-on experience by working on live projects, film shoots, and real client productions, helping them build a strong portfolio and industry-ready skills."
    },
    {
        key: 4,
        question: "Can I hire Sunrising Cinevision for production services?",
        answer: "Absolutely! We offer complete production solutions including film shoots, music videos, podcast recording, chroma studio setup, photography, and event coverage with professional equipment and team."
    },
    {
        key: 5,
        question: "How can I apply or get started?",
        answer: "You can apply online through our website or visit our center for guidance. Our team will help you choose the right course or service based on your goals."
    }
];

function FAQsection() {
    const [isActive, setIsActive] = useState({ status: false, key: 1 });
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: ''
    });

    const handleToggle = (key) => {
        if (isActive.key === key) {
            setIsActive({ status: false });
        } else {
            setIsActive({ status: true, key });
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // Validate that no field is empty
        if (
            !formData.name.trim() ||
            !formData.email.trim() ||
            !formData.phone.trim() ||
            !formData.message.trim()
        ) {
            toast.error('Please fill in all fields.');
            return;
        }
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/contact-forms/`, formData);
            console.log('Form submitted successfully:', response.data);
            toast.success('Form submitted successfully!');
            setFormData({ name: '', email: '', phone: '', message: '' }); // Reset form
        } catch (error) {
            console.error('Error submitting form:', error);
            toast.error('Failed to submit the form. Please try again.');
        }
    };

    return (
        <section className="faq-one">
            <div className="faq-one__bg-color" />
            <div className="container">
                <div className="row">
                    <div className="col-xl-6 col-lg-6">
                        <div className="faq-one__left">
                            <div className="text-left section-title">
                                <div className="section-title__tagline-box">
                                    <span className="section-title__tagline">FAQ</span>
                                </div>
                                <h2 className="section-title__title">
                                    Do You Have Any<br /> Questions?
                                </h2>
                            </div>
                            <div className="accrodion-grp faq-one-accrodion" data-grp-name="faq-one-accrodion-1">
                                {faqData.map((item) => (
                                    <div className={isActive.key === item.key ? "accrodion active" : "accrodion"} onClick={() => handleToggle(item.key)} key={item.key}>
                                        <div className="accrodion-title">
                                            <h4>{item.question}</h4>
                                        </div>
                                        <div className={isActive.key === item.key ? "accrodion-content current" : "accrodion-content"}>
                                            <div className="inner">
                                                <p>{item.answer}</p>
                                            </div>
                                        </div>
                                        <div className="faq-page__count"></div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-6 col-lg-6">
                        <div className="faq-one__right">
                            <h3 className="faq-one__from-title">Contact Sunrising Cinevision </h3>
                            <form
                                className="contact-form-validated faq-one__form"
                                onSubmit={handleSubmit}
                                noValidate="novalidate"
                            >
                                <div className="row">
                                    <div className="col-xl-12 col-lg-12">                                   
                                             <div className="faq-one__input-box">
                                        <input
                                            type="text"
                                            name="name"
                                            placeholder="Your Name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                        <div className="faq-one__input-box">
                                            <input
                                                type="email"
                                                name="email"
                                                placeholder="Your Email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        <div className="faq-one__input-box">
                                            <input
                                                type="text"
                                                name="phone"
                                                placeholder="Phone Number"
                                                value={formData.phone}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="col-xl-12">
                                        <div className="faq-one__input-box text-message-box">
                                            <textarea
                                                name="message"
                                                placeholder="Message here.."
                                                value={formData.message}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="col-xl-12">
                                        <div className="faq-one__btn-box">
                                            <button type="submit" className="thm-btn faq-one__btn">
                                                Submit Now<span />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                            <ToastContainer /> {/* Add ToastContainer for displaying toasts */}
                            <div className="result" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default FAQsection;
